<template>
  <div>
    <div>
        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Cancel
        </button>
        <button v-on:click="saveNewSequence" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save
        </button>
        <button v-on:click="saveDeployNewSequence" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save and Deploy
        </button>

    </div>  
    <div class="grid grid-cols-3">
    <div> <span class="mx-2">Fields</span>
        <DxSortable
                v-model:data="fieldList"
                :element-attr="sortableAttributes"
                :group="draggingGroupName"
                :allow-reordering="true"
                :allow-drop-inside-item="true"
                data="fieldList"            
                @drag-start="onTabDragStart($event)"
                @reorder="onTabDrop($event)"
                @add="onTabDrop($event)"
            >
                <div v-for="tas in fieldList" :key="tas.dataField" class="card dx-card dx-theme-text-color dx-theme-background-color m-2">
                        
                        
                        <div v-if="checkVal(tas)" class="card-subject p-2">{{tas.label.text}}</div>
                        <div v-else-if="tas.itemType == 'empty'" class="card-subject p-2" data-allow-copy="true">Empty</div>
                        <div v-else class="card-subject p-2">{{ tas.label.text }}</div>
                        
                </div>


            </DxSortable>
    </div>
    <div class="col-span-2"> <span class="mx-2">Edit Layout Name and Column count.</span> 
        <div class="flex flex-row">
            <!-- <input type="text" v-model="grpName"> -->
            <DxTextBox width="200px" v-model="grpName" /> 
            
            <DxSelectBox
                width="80px"
                v-model="grpColCount"
                :items="columnCounts"
                :value="columnCounts[0]"
                
            />   
            <button v-on:click="addNode" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">add</button>
        </div>
        <DxSortable
                v-model:data="layoutDef"              
                item-orientation="vertical"
                drag-direction="vertical" 
                group="kk"          
                :allow-reordering="true"
                data="layoutDef"            
                @drag-start="onTabDragStart($event)"
                @reorder="onTabDrop($event)"
                @add="onTabDrop($event)"
                :allow-drop-inside-item="true"
            >
                <!-- <div v-for="tas in tags2" :key="tas.name" class="card dx-card dx-theme-text-color dx-theme-background-color m-2">
                        <div class="card-subject p-2">{{ tas.name }}</div>
                </div> -->
                <div v-for="(task, index) in layoutDef" :key="task.name" style="background: #86C285;margin:5px;" class="p-2">
                    <div class="list-title dx-theme-text-color">
                        <span class=""> {{ task.name }} </span> 
                        <span class=""> {{task.colCount}}</span>
                        <div class="flex float-right">
                            <i class="fas fa-pause fa-rotate-90  mr-4" v-on:click="addEmptyField(index)"></i> 
                            <i class="fas fa-trash-alt text-red-500" v-on:click="deleteItem(index)"></i>
                        </div>
                    </div>
                    <DxSortable
                        v-model:data="task.items"
                        data="task.items"                       
                        :element-attr="sortableAttributes"                   
                        :group="draggingGroupName"
                        @drag-start="onTabDragStart($event)"
                        @reorder="onTabDrop($event)"
                        @add="onTabDrop($event)"
                        :allow-reordering="true">

                        <div v-for="tas in task.items" :key="tas"  class="card dx-card dx-theme-text-color dx-theme-background-color m-2">
                            
                            <div v-if="checkVal(tas)" class="card-subject p-2">{{tas.label.text}}</div>
                            <div v-else class="card-subject p-2">{{ tas.label.text }}</div>
                        </div>

                    </DxSortable>
                </div>

            </DxSortable>
    </div>
    </div>
  </div>
</template>

<script>
import DxSortable from 'devextreme-vue/sortable';
import { DxTextBox,DxSelectBox } from 'devextreme-vue';
import {getFieldsList,getLayout,setLayout,getLineItemLayout,setDeployLayout} from '../../base.js';
export default {
     props:{
        modulekey:String,
        studio:Boolean,
        route_slug:String
    },
    components: {
            DxTextBox,
            DxSortable,
            DxSelectBox
            
        },
    computed:{
        valueString() {
            let mod=JSON.stringify(this.layoutDef, null, 2)
            return mod;
        },
    },    
    data() {
            return { 
                grpName:"",
                grpColCount:1,
                draggingGroupName:"shared",
                sortableAttributes: {
                    class: 'classjj'
                },
                columnCounts:[1,2,3,4,5],
                lineItemField:[],
                defaultFieldList:[],
                fieldList:[],
                layoutDef:[],
                fieldList1: [{
                        name:'JavaScript',
                        dataField: "name",                        
                        label:{
                            text:"Name"
                        },
                        items:["sdf","ghj"]
                        }, 
                        {
                        name:'vue script',
                        dataField: "name1",                        
                        label:{
                            text:"Name1"
                        },
                        items:["qwe","rty","jhg"]
                        }, 
                        {
                        name:'angular script',
                        dataField: "name1",                        
                        label:{
                            text:"Name1"
                        },
                        items:["loi"]
                        }],
                tags2: [{
                        name:'JavaScript',
                        items:["sdf","ghj"]
                        }, 
                        {
                        name:'vue script',
                        items:["qwe","rty","jhg"]
                        }, 
                        {
                        name:'angular script',
                        items:["loi"]
                        }],
                              
                field_List  : new Object(), 
            } 
        },
    methods: {
        deleteItem(item) {
        // Perform the delete action using the "item" parameter
            this.layoutDef.splice(item, 1);    
        },
        addEmptyField(item)
        {
            let ab = {             
                    itemType : "empty",
                    label:
                    {
                        text:"| |"
                    }                   
                };
            this.layoutDef[item].items.push(ab);
        },
        saveLayout(){
            alert("save test");
            //console.log(this.layoutDef);
        },
        addNode()
        {
            let ab = {                
                name: this.grpName,
                itemType : "group",
                colCount: this.grpColCount,
                items: []
            };
            //console.log("hjh",this.grpColCount);
            //console.log(this.layoutDef);
            //console.log(JSON.stringify(this.layoutDef));

            this.layoutDef.push(ab); 
            
        },
        checkVal(val)
        {
            if(val instanceof Object)
            {
                return true;
            }
            return false;
        },
        checkEmpty()
        {
            
        },
        onTabDragStart(e) {
            e.itemData = e.fromData[e.fromIndex];
            },
        onListReorder(e) {
            const list = this.tags.splice(e.fromIndex, 1)[0];
            this.tags.splice(e.toIndex, 0, list);
            },
        onTabDrop(e) {
            e.fromData.splice(e.fromIndex, 1);
            e.toData.splice(e.toIndex, 0, e.itemData);
            },
        saveNewSequence() {
            let model=JSON.stringify(this.layoutDef, null, 2);   
            //console.log(model);             
            //post data
            this.errors = {};                    
            setLayout(this.modulekey,"editview",this.studio,model,this.route_slug).then(response => {
                //console.log('get'+JSON.stringify(response.data));
            }).catch(error => {
                if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
                }
            });
                            
        },

         saveDeployNewSequence(){
     let model=JSON.stringify(this.layoutDef, null, 2);   
            //console.log(model);             
            //post data
            this.errors = {};                    
            setDeployLayout(this.modulekey,"editview",this.studio,model,this.route_slug).then(response => {
                //console.log('get'+JSON.stringify(response.data));
            }).catch(error => {
                if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
                }
            });
                     
         },


    },
    created: function () {

        getLineItemLayout(this.modulekey,this.studio,this.route_slug).then(response =>
        {
            //todo check empty
           // console.log(Object.assign([], response.data));
            this.lineItemField = Object.values(response.data); 
            //this.lineItemField = response.data;           
          
        });
        //get field list of current module
        this.errors = {};                    
        getFieldsList(this.modulekey,this.studio,false,this.route_slug).then(response => {
        
            //console.log(Object.values(response.data).concat(this.lineItemField));
            this.fieldList = Object.values(response.data).concat(this.lineItemField);                       
            this.defaultFieldList = Object.values(response.data).concat(this.lineItemField); 

        }).catch(error => {            
            if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
            }
        });
        //get the editview layout
        getLayout(this.modulekey,"editview",this.studio,this.route_slug).then(response => {
            
            if(response.data != "")
            {
                //console.log(this.fieldList);
                this.layoutDef = response.data;
                this.fieldList = this.fieldList.filter(item => !this.layoutDef.find(field => field.items.find(layoutItem =>item.dataField === layoutItem.dataField)));
                
                                 
            }

            
            
            /* this.layoutDef = this.layoutDef.filter(item => item.items.filter(field => !this.defaultFieldList.find(layoutItem =>field.dataField === layoutItem.dataField)));  
            let defaultFieldList =this.defaultFieldList ;
            let users= this.layoutDef.filter((item) =>
                            
                            item.items.some(lfields => this.defaultFieldList.find(dfield => dfield.dataField === lfields.dataField)
                              
                                                          
                            )
                 
            );
            console.log(users); */

        
        }).catch(error => {
            
            /* if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
            } */
        });
    },
    mounted() {
        
    },
}
</script>

<style>
.classjj{
    min-height: 20px;
    /* background: rgba(59, 130, 246, 0.5) */
    background: rgb(113, 181, 112); 
    /* background: #17a2b8; */
}
</style>